import { map, type OperatorFunction } from 'rxjs';

import { type ApiResponse } from '../types/api-response';

import { assertNonNull } from './assert-non-null';

export function extractDataNonNull<T>(): OperatorFunction<ApiResponse<T>, T> {
  return map((res) => {
    assertNonNull(res.data);
    return res.data;
  });
}

export function extractMappedDataNonNull<TDto, TDomain>(
  mapper: (dto: TDto) => TDomain,
): OperatorFunction<ApiResponse<TDto>, TDomain> {
  return map((res) => {
    assertNonNull(res.data);
    return mapper(res.data);
  });
}
